import { render, staticRenderFns } from "./BaseImputLogic.vue?vue&type=template&id=7089dadc&scoped=true"
import script from "./BaseImputLogic.vue?vue&type=script&lang=js"
export * from "./BaseImputLogic.vue?vue&type=script&lang=js"
import style0 from "./BaseImputLogic.vue?vue&type=style&index=0&id=7089dadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089dadc",
  null
  
)

export default component.exports